import React, { useState } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
import "bootstrap";
import Accordion from "react-bootstrap/Accordion";
import dateFormat, { masks } from "dateformat";
import { leaseDateFormat } from "../../utils/utils";
class CamDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      camDetails: this.props.camDetails,
      camDataApplicable: this.props.camDataApplicable,
    };
  }

  render() {
    return (
      <div className="tabHolder mb-4">
        <div className="row tabForm">
          <Accordion defaultActiveKey="0">
            {this.state.camDataApplicable == "yes" ? (
              this.state.camDetails.map(function (cam, index) {
                if (cam.camLogicValue == 1) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {`Period `}
                              {` `}
                              {cam.period}
                              {` `}
                              {`-`}
                              {` `}
                              {cam.camLogicText}
                              {` - `}
                              {`( Period Term - ${
                                cam.periodTermYY == "" ? "0" : cam.periodTermYY
                              }Y -${
                                cam.periodTermMM == "" ? "0" : cam.periodTermMM
                              }M -${
                                cam.periodTermDD == "" ? "0" : cam.periodTermDD
                              }D )`}
                              {` - `}
                              {`From ${leaseDateFormat(cam.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(cam.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term(YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.periodTermYY == ""
                                            ? "0"
                                            : cam.periodTermYY}
                                          {"-"}
                                          {cam.periodTermMM == ""
                                            ? "0"
                                            : cam.periodTermMM}
                                          {"-"}
                                          {cam.periodTermDD == ""
                                            ? "0"
                                            : cam.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Paid At{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camPaidAt === undefined
                                            ? "-"
                                            : cam.camPaidAt}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <label className="col-sm-4 col-form-label">
                                            From{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {leaseDateFormat(cam.fromDate)}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {/* {dateFormat(
                                            cam.toDate,
                                            "dd mmm yyyy"
                                          )} */}
                                          {leaseDateFormat(cam.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM UOM{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camUom}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          On Area{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.onArea}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camRate}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camDueDate}
                                          {`-`}
                                          {cam.camDueType}
                                          {`-`}
                                          {cam.camDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="row mb-3">
                                    <div className="col-lg-6 fitoutPopup">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Actualization{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {cam.camActualization}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {cam.camActualization == "Yes" && (
                                    <div className="camAct row">
                                      <div className="col-lg-6 fitoutPopup">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-0">
                                            <label
                                              className="col-sm-4 col-form-label"
                                              style={{
                                                fontWeight: "600",
                                                fontSize: "14px",
                                              }}
                                            >
                                              CAM Actualization Basis <br /> (
                                              Times Actual Cost){" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label
                                              className="col-sm-7 col-form-label"
                                              style={{ fontSize: "14px" }}
                                            >
                                              {cam.camActualizationBasis}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6 fitoutPopup">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Actualization Period{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camActualizationPeriod}
                                              {" Months"}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Capped{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camCapped}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {cam.camCapped == "Yes" && (
                                    <div className="camCapped row">
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped UOM{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedUom}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped on Area{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedOnArea}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped Rate{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedRate}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped Rate Term{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedRateTerm}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (cam.camLogicValue == 2) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {`Period `}
                              {` `}
                              {cam.period}
                              {` `}
                              {`-`}
                              {` `}
                              {cam.camLogicText}
                              {` - `}
                              {`( Period Term - ${
                                cam.periodTermYY == "" ? "0" : cam.periodTermYY
                              }Y -${
                                cam.periodTermMM == "" ? "0" : cam.periodTermMM
                              }M -${
                                cam.periodTermDD == "" ? "0" : cam.periodTermDD
                              }D )`}
                              {` - `}
                              {`From ${leaseDateFormat(cam.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(cam.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term(YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.periodTermYY == ""
                                            ? "0"
                                            : cam.periodTermYY}
                                          {"-"}
                                          {cam.periodTermMM == ""
                                            ? "0"
                                            : cam.periodTermMM}
                                          {"-"}
                                          {cam.periodTermDD == ""
                                            ? "0"
                                            : cam.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(cam.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(cam.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Revenue Share (%){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.revenueShare}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Cam Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camDueDate}
                                          {`-`}
                                          {cam.camDueType}
                                          {`-`}
                                          {cam.camDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="row">
                                    <div className="col-lg-6 fitoutPopup">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Actualization{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {cam.camActualization}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {cam.camActualization == "Yes" && (
                                    <div className="camAct row">
                                      <div className="col-lg-6 fitoutPopup">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-0">
                                            <label
                                              className="col-sm-4 col-form-label"
                                              style={{
                                                fontWeight: "600",
                                                fontSize: "14px",
                                              }}
                                            >
                                              CAM Actualization Basis <br /> (
                                              Times Actual Cost){" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label
                                              className="col-sm-7 col-form-label"
                                              style={{ fontSize: "14px" }}
                                            >
                                              {cam.camActualizationBasis}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6 fitoutPopup">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Actualization Period{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camActualizationPeriod}
                                              {" Months"}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Capped{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camCapped}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {cam.camCapped == "Yes" && (
                                    <div className="camCapped row">
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped UOM{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedUom}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped on Area{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedOnArea}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped Rate{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedRate}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped Rate Term{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedRateTerm}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (cam.camLogicValue == 3) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {`Period `}
                              {` `}
                              {cam.period}
                              {` `}
                              {`-`}
                              {` `}
                              {cam.camLogicText}
                              {` - `}
                              {`( Period Term - ${
                                cam.periodTermYY == "" ? "0" : cam.periodTermYY
                              }Y -${
                                cam.periodTermMM == "" ? "0" : cam.periodTermMM
                              }M -${
                                cam.periodTermDD == "" ? "0" : cam.periodTermDD
                              }D )`}
                              {` - `}
                              {`From ${leaseDateFormat(cam.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(cam.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term(YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.periodTermYY == ""
                                            ? "0"
                                            : cam.periodTermYY}
                                          {"-"}
                                          {cam.periodTermMM == ""
                                            ? "0"
                                            : cam.periodTermMM}
                                          {"-"}
                                          {cam.periodTermDD == ""
                                            ? "0"
                                            : cam.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Cam Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(cam.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(cam.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-12">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-2 col-form-label">
                                          Revenue Share (%)
                                        </label>
                                        <div className="col-sm-10 slabWidthDesktop">
                                          <div
                                            className="tableContainer"
                                            style={{ padding: "15px" }}
                                          >
                                            <table className="table tableSimple tableSimpleWithNoFlex">
                                              <thead>
                                                <tr>
                                                  <th scope="col">SLAB</th>
                                                  <th scope="col">FROM</th>
                                                  <th scope="col">To</th>
                                                  <th scope="col">
                                                    Revenue Share (%)
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {cam.slabs.length > 0 &&
                                                  cam.slabs.map(
                                                    (name, index) => (
                                                      <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{name.from}</td>
                                                        <td>{name.to}</td>
                                                        <td>{name.percent}</td>
                                                      </tr>
                                                    )
                                                  )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Rate Term{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camRateTerm}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Cam Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camDueDate}
                                          {`-`}
                                          {cam.camDueType}
                                          {`-`}
                                          {cam.camDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="row">
                                    <div className="col-lg-6 fitoutPopup">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Actualization{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {cam.camActualization}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {cam.camActualization == "Yes" && (
                                    <div className="camAct row">
                                      <div className="col-lg-6 fitoutPopup">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-0">
                                            <label
                                              className="col-sm-4 col-form-label"
                                              style={{
                                                fontWeight: "600",
                                                fontSize: "14px",
                                              }}
                                            >
                                              CAM Actualization Basis <br />(
                                              Times Actual Cost){" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label
                                              className="col-sm-7 col-form-label"
                                              style={{ fontSize: "14px" }}
                                            >
                                              {cam.camActualizationBasis}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6 fitoutPopup">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Actualization Period{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camActualizationPeriod}
                                              {" Months"}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Capped{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camCapped}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {cam.camCapped == "Yes" && (
                                    <div className="camCapped row">
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped UOM{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedUom}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped on Area{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedOnArea}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped Rate{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedRate}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped Rate Term{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedRateTerm}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                } else if (cam.camLogicValue == 4) {
                  return (
                    <div className="container-fluid p-0">
                      <div className="row prospectAccordion">
                        <div className="col-lg-12 p-0">
                          <Accordion.Item eventKey={index}>
                            <Accordion.Header>
                              {`Period `}
                              {` `}
                              {cam.period}
                              {` `}
                              {`-`}
                              {` `}
                              {cam.camLogicText}
                              {` - `}
                              {`( Period Term - ${
                                cam.periodTermYY == "" ? "0" : cam.periodTermYY
                              }Y -${
                                cam.periodTermMM == "" ? "0" : cam.periodTermMM
                              }M -${
                                cam.periodTermDD == "" ? "0" : cam.periodTermDD
                              }D )`}
                              {` - `}
                              {`From ${leaseDateFormat(cam.fromDate)}`}
                              {` `}
                              {`To ${leaseDateFormat(cam.toDate)}`}
                            </Accordion.Header>
                            <Accordion.Body>
                              <div className="container-fluid">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.period}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Period Term(YY-MM-DD){" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.periodTermYY == ""
                                            ? "0"
                                            : cam.periodTermYY}
                                          {"-"}
                                          {cam.periodTermMM == ""
                                            ? "0"
                                            : cam.periodTermMM}
                                          {"-"}
                                          {cam.periodTermDD == ""
                                            ? "0"
                                            : cam.periodTermDD}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Cam Logic{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camLogicText}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          From <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(cam.fromDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          To <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {leaseDateFormat(cam.toDate)}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Cam Rate{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camRate}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Cam Frequency{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Due Date{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camDueDate}
                                          {`-`}
                                          {cam.camDueType}
                                          {`-`}
                                          {cam.camDueFrequency}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM as Rent %{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camRentPercent}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          Applicable on Rent Period{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.applicableRentPeriod}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="row">
                                    <div className="col-lg-6 fitoutPopup">
                                      <div className="inputContainer col-lg-12 col-md-12">
                                        <div className="row mb-3">
                                          <label className="col-sm-4 col-form-label">
                                            CAM Actualization{" "}
                                            <span className="astrik">*</span>
                                          </label>
                                          <label className="col-sm-7 col-form-label">
                                            {cam.camActualization}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {cam.camActualization == "Yes" && (
                                    <div className="camAct row">
                                      <div className="col-lg-6 fitoutPopup">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-0">
                                            <label
                                              className="col-sm-4 col-form-label"
                                              style={{
                                                fontWeight: "600",
                                                fontSize: "14px",
                                              }}
                                            >
                                              CAM Actualization Basis <br />
                                              (Times Actual Cost){" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label
                                              className="col-sm-7 col-form-label"
                                              style={{ fontSize: "14px" }}
                                            >
                                              {cam.camActualizationBasis}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6 fitoutPopup">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Actualization Period{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camActualizationPeriod}
                                              {" Months"}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="row">
                                  <div className="col-lg-6">
                                    <div className="inputContainer col-lg-12 col-md-12">
                                      <div className="row mb-3">
                                        <label className="col-sm-4 col-form-label">
                                          CAM Capped{" "}
                                          <span className="astrik">*</span>
                                        </label>
                                        <label className="col-sm-7 col-form-label">
                                          {cam.camCapped}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                  {cam.camCapped == "Yes" && (
                                    <div className="camCapped row">
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped UOM{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedUom}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped on Area{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedOnArea}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped Rate{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedRate}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="inputContainer col-lg-12 col-md-12">
                                          <div className="row mb-3">
                                            <label className="col-sm-4 col-form-label">
                                              CAM Capped Rate Term{" "}
                                              <span className="astrik">*</span>
                                            </label>
                                            <label className="col-sm-7 col-form-label">
                                              {cam.camCappedRateTerm}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        </div>
                      </div>
                    </div>
                  );
                }
              }, this)
            ) : (
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <h6 className="text-center" style={{ padding: "15px" }}>
                      CAM Not Applicable
                    </h6>
                  </div>
                </div>
              </div>
            )}
          </Accordion>
          {this.state.camDataApplicable == "yes" && (
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6">
                  <div className="inputContainer col-lg-12 col-md-12">
                    <div className="row mb-3">
                      <label className="col-sm-4 col-form-label">
                        Notes
                        <span className="astrik">*</span>
                      </label>
                      <label className="col-sm-7 col-form-label">
                        {this.props.camNotes}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
export default withRouter(CamDetails);
